/**
 * Wrapper around Raphael text path used as el of the Signature View
 * (created on fontChange and when user chooses to create new note )
 */

var HoverShapeView = require('../hoverShape/hoverShape'),
    CreateSignatureEl = require('./createSignatureEl'),
    defaultAttrs = require('./signatureUIModel').prototype.defaults;


module.exports = HoverShapeView.extend({

    initialize: function( options ) {

        HoverShapeView.prototype.initialize.apply( this, arguments );

        this.listenTo( this.channel, 'hoverSignature:consultGroupChange', this.changeFill );

        this.originalBBoxHeight = 0;

        this.scale = this.originalScale;

    },

    createEl: function( ) {

        return CreateSignatureEl(
            this.paper,
            this.ox,
            this.oy,
            this.note.get('creationUserDesc'),
            defaultAttrs.activeFont,
            parseFloat( defaultAttrs.baseFontSize ),
            this.channel.request( 'getColorToApplyToShape', this.note )
        );

    },

    render: function() {

        HoverShapeView.prototype.render.apply( this, arguments );

        this.originalBBoxHeight = this.el.getBBox().height;

        return this;

    },

    /**
     * Previously: always at 0,0 and was transformed with the mouse position.
     * Changed to reflect that mouse position could move in between canvas 're-renders',
     * so now we take the original position into account to derive dx, dy.
     * Note: have since removed attempt to reposition on re-render but left the above logic
     * here in case there's a need to revisit, and b/c logic will still work.
     *
     */
    onMouseMove: function( x, y ) {

        var yOffset =
            ( this.originalBBoxHeight * ( this.scale ) ) ;

        var dx = x - this.ox;
        var dy = y - this.oy;

        var t = 'T' + dx + ',' +  ( dy + yOffset );

        this.el.transform( t );

    },

    scale: function( scale, lastScale ) {

        this.scale = scale;
        this.el.scalePathWithCurves.apply( this.el, arguments );
    },

    deriveShapeFromClone: function() {

        this.el.bakeTransform();
        return HoverShapeView.prototype.deriveShapeFromClone.apply( this, arguments );

    },

    changeFill: function( color ) {
        this.el.attr('fill', color);
    }


});





/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/signature/hoverSignature.js
 ** module id = 382
 ** module chunks = 0
 **/